import { FormRichTextEditor } from '@exam-management/rich-text-editor';
import { Box, DeleteOutlineRoundedIcon, Flex, FormRadio, IconButton } from '@shared/components';

import { useUploadImageForQuestion } from '../../hooks';

export interface QContentAnswerFormFieldsProps {
  index: number;
  label: string;
  value: string;
  onDelete: (index: number) => void;
  questionId?: string;
  correct: boolean;
  correctAnswerName: string;
  choiceName: string;
}

export default function QContentAnswerFormFields(props: Readonly<QContentAnswerFormFieldsProps>) {
  const {
    index,
    label,
    value,
    onDelete,
    questionId,
    correct: isCorrectAnswer,
    correctAnswerName,
    choiceName,
  } = props;
  const { handleUpload, loading: isLoading } = useUploadImageForQuestion({
    questionId,
  });

  const handleDelete = () => {
    onDelete(index);
  };

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(3),
        bgcolor: isCorrectAnswer ? theme.palette.success.light : theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        p: theme.spacing(3),
        width: '100%',
      })}
    >
      <FormRadio
        name={correctAnswerName}
        value={value}
        label={label}
        radioProps={{
          color: 'success',
          sx: (theme) => ({
            p: theme.spacing(0),
            color: theme.palette.grey[400],
          }),
        }}
        slotProps={{
          typography: {
            variant: 'body1Semibold',
          },
        }}
        sx={(theme) => ({
          m: theme.spacing(0),
          p: theme.spacing(0),
          mr: theme.spacing(2),
          height: '100%',
          minHeight: 56,
          gap: theme.spacing(2),
          flexShrink: 0,
        })}
      />
      <Box sx={{ flexGrow: 1 }}>
        <FormRichTextEditor
          key={`rich-text-editor-${index}`}
          onImageUpload={handleUpload}
          loading={isLoading}
          name={choiceName}
          placeholder='กรอกตัวเลือกที่นี่'
        />
      </Box>
      <IconButton
        onClick={handleDelete}
        size='small'
        sx={{
          color: 'grey.600',
          minHeight: 56,
          height: '100%',
        }}
        disableRipple
      >
        <DeleteOutlineRoundedIcon />
      </IconButton>
    </Flex>
  );
}
